export default {"src":"/_next/static/media/Colorectalconditions.62ff6931.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};